import { useEffect, useState } from 'react';
// import { PermissionApi, UserOrganizeApi, RoleApi, UserApi, VillageApi } from 'gmrfid';


import { useHistory } from 'troyfe';
import { arrayToTree } from '../../utils';
import Block from './style';
import Control from './control';
import Quick from './quick';
import store from '@/store';

/* 服务分类 */
const sceneFilterFn = (_arr, key) => {
  const map = {};
  const dest = [];
  for (let i = 0; i < _arr.length; i++) {
    const ai = _arr[i];
    if (!map[ai[key]]) {
      dest.push({
        children: [ai],
        category: ai?.category,
        title: ai[key],
      });
      map[ai[key]] = ai;
    } else {
      for (let j = 0; j < dest.length; j++) {
        const dj = dest[j];
        if (dj.title == ai[key]) {
          dj.children.push(ai);
          break;
        }
      }
    }
  }
  return dest;
};

export default function Page() {
  const history = useHistory();
  const [appState, appDispatchers] = store.useModel('app');

  // const { basicInformation } = useSelector((state) => state.app);
  const { userInf } = appState.basicInformation;
  const [authenticationType, setAuthenticationType] = useState(null);
  const [menuData, setMenuData] = useState([]);
  const [adminData, setAdminData] = useState([]);
  const [sonData, setSonData] = useState([]);
  const [identityType, setIdentityType] = useState();
  const [communityStatistics, setCommunityStatistics] = useState({
    adminTotal: '/',
    deptTotal: '/',
    servicerTotal: '/',
    usePeople: '/',
  });
  const [userNum, setUserNum] = useState({
    building: '/',
    house: '/',
    parking: '/',
    people: '/',
  });
  const [projectObj, setProjectObj] = useState({});
  const userObj = JSON.parse(sessionStorage.getItem('user'));
  const [list, setList] = useState([]);
  const [user, setUser] = useState({});
  const [identityText, setIdentityText] = useState('');
  // useEffect(() => {
  //   if (userObj?.organizeId) {
  //     VillageApi.detail({
  //       id: userObj?.organizeId,
  //     }).then((res) => {
  //       if (res.status === 200 && res.data) {
  //         setProjectObj(res.data);
  //         /* 已认证 */
  //         if (res.data.verifyState === 'VERIFIED') {
  //           setAuthenticationType(true);
  //           UserOrganizeApi.villageHomeCount({}).then((res1) => {
  //             if (res1.data) {
  //               setCommunityStatistics(res1.data);
  //             }
  //           });
  //           VillageApi.villageCount({}).then((res2) => {
  //             if (res2.data) {
  //               setUserNum(res2.data);
  //             }
  //           });
  //           RoleApi.homeRoleList({}).then((res3) => {
  //             if (res3.data) {
  //               res3.data?.map((item) => {
  //                 if (userInf?.id === res.data?.creatorId) {
  //                   setIdentityText('创建者');
  //                 } else if (userInf?.id === item.id) {
  //                   setIdentityText(item.roleName);
  //                 }
  //               });
  //               setAdminData(res3.data.filter((item) => item.roleType === 'SUB_ADMIN'));
  //               setSonData(res3.data.filter((item) => item.roleType !== 'SUB_ADMIN'));
  //             }
  //           });
  //           PermissionApi.applicationList({
  //             quickEntry: true,
  //           }).then((res4) => {
  //             setMenuData(res4?.data);
  //           });
  //           PermissionApi.applicationList({
  //             param: {
  //               quickEntry: false,
  //             },
  //           }).then((res5) => {
  //             if (res5.status === 200) {
  //               const data1 = arrayToTree(res5.data, 'id', 'parentId');
  //               const data2 = sceneFilterFn(data1, 'category');
  //               const arr = [];
  //               data2.map((item) => {
  //                 if (item.category === 'BASE') {
  //                   arr[0] = item;
  //                 }
  //                 if (item.category === 'SMART') {
  //                   arr[1] = item;
  //                 }
  //               });
  //               setList(arr);
  //             }
  //           });
  //           UserApi.getUserInfoPC({}).then((res6) => {
  //             if (res6.status === 200) {
  //               setUser(res6.data);
  //             }
  //           });
  //         }
  //       }
  //     });
  //   }
  // }, []);

  const options = {
    menuData,
    authenticationType,
    communityStatistics,
    userNum,
    adminData,
    sonData,
    identityType,
    projectObj,
    userInf,
    list,
    history,
    user,
    identityText,
  };

  return (
    <Block>
      <div className="left">
        <Control authenticationType={authenticationType} options={options} />
      </div>
      <div className="right">
        <Quick options={options} />
      </div>
    </Block>
  );
}
